import React from 'react';
import { Input } from '@/components/ui/input';

/** From / To date inputs (YYYY-MM-DD); empty = the report's default range. */
export const DateRangeBar = ({ from, to, onChange, testPrefix }) => (
  <div className="flex items-center gap-2 text-sm text-gray-600">
    <span>From</span>
    <Input type="date" value={from} onChange={(e) => onChange({ from: e.target.value, to })} className="w-[150px] bg-white" data-testid={`${testPrefix}-from`} />
    <span>to</span>
    <Input type="date" value={to} onChange={(e) => onChange({ from, to: e.target.value })} className="w-[150px] bg-white" data-testid={`${testPrefix}-to`} />
  </div>
);

export default DateRangeBar;
